import React from 'react';
import { Label } from 'reactstrap';
import { connect } from 'react-redux';
import classnames from 'classnames';
import { compose, withStateHandlers, withHandlers } from 'recompose';
import Input from '../../../../components/Input/Input';
import './TestConnectionVariable.scss';

const mapStateToProps = state => ({
  variables: state.variables.entities,
});

const initialState = ({ isStatic, staticValue }) => ({
  localVariables: [],
  localValue: isStatic ? staticValue : '',
});

const stateUpdaters = {
  setLocalVariables: () => localVariables => ({ localVariables }),
  setLocalValue: () => localValue => ({ localValue }),
};

const renderSuggestion = () => (suggestion, { isHighlighted }) => (
  <div
    className={classnames('test-connection-variable__suggestions-item', {
      'test-connection-variable__suggestions-item--selected': isHighlighted,
    })}
  >
    <div className="test-connection-variable__suggestion-name">
      <span>{suggestion.name}</span>
    </div>
  </div>
);

const onSuggestionsFetchRequested = ({ variables, setLocalVariables }) => ({ value }) => {
  const localVariables = variables.filter(item =>
    item.name.toLowerCase().indexOf(value.toLowerCase()) !== -1);

  setLocalVariables(localVariables);
};

const doesValueExist = ({ connection, index }) => (value, checkWithIndex = false) => {
  if (!connection) return false;
  const { variables } = connection;
  const variableIndex = variables.findIndex(variable => variable.name === value.name);
  if (checkWithIndex) {
    return variableIndex > -1 && variableIndex === index;
  }
  return variableIndex > -1;
};

const onSuggestionSelected = props => (e, { suggestionValue }) => {
  const { variablesModal, index, updateVariables, setLocalValue } = props;
  const { name } = suggestionValue;
  variablesModal[index] = { ...variablesModal[index], name };
  setLocalValue(name);
  updateVariables(variablesModal);
};

const onValueChange = ({ setLocalValue }) => e => {
  setLocalValue(e.target.value);
};

const updateStaticValue = props => () => {
  const { localValue, updateVariables, variablesModal, index } = props;
  variablesModal[index] = { ...variablesModal[index], value: localValue };
  updateVariables(variablesModal);
};

const enhance = compose(
  connect(mapStateToProps, null),
  withStateHandlers(initialState, stateUpdaters),
  withHandlers({ renderSuggestion, onSuggestionsFetchRequested, doesValueExist }),
  withHandlers({ onSuggestionSelected, onValueChange, updateStaticValue }),
);

const TestConnectionVariable = props => {
  const {
    name,
    localValue,
    onValueChange,
    updateStaticValue,
  } = props;

  return (
    <div>
      <Label className="test-connection-variable">
        <span className="test-connection-variable__label">{name}</span>

        <Input
          className="test-connection-variable__input"
          value={localValue}
          onChange={onValueChange}
          onBlur={updateStaticValue}
        />
      </Label>
    </div>
  )
};

export default enhance(TestConnectionVariable);
